import http from "./httpService";
import { reactive } from "vue";
import dayjs from "dayjs";

class SFIService {
  async getMetrics(
    startDate,
    endDate,
    age = [],
    subject = [],
    topic = [],
    period = "custom"
  ) {
    const params = {
      startDate: startDate,
      endDate: endDate,
      period: period,
    };

    // Add filter parameters if they exist
    if (age && age.length > 0) {
      params.age = age.join(",");
    }

    if (subject && subject.length > 0) {
      params.subject = subject.join(",");
    }

    if (topic && topic.length > 0) {
      params.topics = topic.join(",");
    }

    const response = await http.get("/sfi-google-classroom-addon/metrics", {
      params: params,
    });
    return response;
  }

  async exportMetrics(startDate, endDate) {
    const params = {
      startDate: startDate,
      endDate: endDate,
    };

    // Use responseType: 'blob' to handle binary data
    return await http.get("/sfi-google-classroom-addon/metrics/export", {
      params: params,
      responseType: "blob",
    });
  }

  async getEducators({
    page = 1,
    limit = 10,
    orderBy = "name",
    orderDir = "desc",
    search = "",
  } = {}) {
    const params = {
      page,
      limit,
      order_by: orderBy,
      order_dir: orderDir,
    };

    if (search) {
      params.search = search;
    }

    return await http.get("/sfi-google-classroom-addon/educators", {
      params,
    });
  }

  async exportEducatorsCsv({ search = "" } = {}) {
    const params = {};
    if (search) params.search = search;

    return await http.get("/sfi-google-classroom-addon/educators-csv", {
      params,
      responseType: "blob",
    });
  }
}

export const sfiStore = reactive({
  startDate: dayjs().startOf("year").format("YYYY-MM-DD"),
  endDate: dayjs().format("YYYY-MM-DD"),
  data: {},
  loading: true,
  error: null,
  age: [],
  subject: [],
  topic: [],
  period: "custom", // Default period

  // Method to fetch data based on current filters
  async fetchData() {
    try {
      this.loading = true;
      this.error = null;
      const sfiService = new SFIService();
      const response = await sfiService.getMetrics(
        this.startDate,
        this.endDate,
        this.age,
        this.subject,
        this.topic,
        this.period
      );

      if (response.status === 200 && response.data.data) {
        this.data = response.data.data;
      } else {
        this.error = "Error fetching data";
      }

      return this.data;
    } catch (error) {
      this.error = error.message || "Failed to fetch metrics";
      console.error("Error fetching SFI metrics:", error);
      throw error;
    } finally {
      this.loading = false;
    }
  },

  // Export metrics with current filters
  async exportMetricsData() {
    try {
      this.loading = true;
      this.error = null;
      const sfiService = new SFIService();
      return await sfiService.exportMetrics(this.startDate, this.endDate);
    } catch (error) {
      this.error = error.message || "Failed to export metrics";
      console.error("Error exporting SFI metrics:", error);
      throw error;
    } finally {
      this.loading = false;
    }
  },
});

export default new SFIService();
